import React, { createContext, useContext, useState, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { base44 } from '@/api/base44Client';

const ChatContext = createContext(null);

const FALLBACK_SETTINGS = {
  chatbot_available: false,
  live_chat_available: false,
  phone_number: '+44 151 528 3001',
  email: 'sales@motionreality.co.uk',
  website_url: 'https://motionreality.co.uk',
  hours: 'Mon–Fri 9am–6pm · Sat 10am–4pm',
};

export function ChatProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const { data: settingsList = [] } = useQuery({
    queryKey: ['customer-service-settings'],
    queryFn: () => base44.entities.CustomerServiceSettings.list(),
  });

  const settings = useMemo(() => {
    const s = (settingsList || []).find((x) => x.setting_key === 'global');
    return { ...FALLBACK_SETTINGS, ...(s || {}) };
  }, [settingsList]);

  const available = !!settings.chatbot_available;

  const value = useMemo(() => ({
    settings,
    available,
    isOpen: available && isOpen,
    open: () => { if (available) setIsOpen(true); },
    close: () => setIsOpen(false),
    toggle: () => { if (available) setIsOpen((v) => !v); },
  }), [settings, available, isOpen]);

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
}

export function useChat() {
  const ctx = useContext(ChatContext);
  if (!ctx) {
    return { settings: FALLBACK_SETTINGS, available: false, isOpen: false, open: () => {}, close: () => {}, toggle: () => {} };
  }
  return ctx;
}